package com.vizio.redwolf.dms.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@JsExport
@Serializable
data class VizioPayData(
    @SerialName("linkedAt") val linkedAt: Long,
    @SerialName("linked") val linked: Boolean
)